/* tslint:disable */
/* eslint-disable */
/* @relayHash e6c2a35f668fc64775845f305f5d9915 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type shoppingWithRootQueryVariables = {
    urlLabel?: string | null;
    previewId?: string | null;
    isTrade: boolean;
};
export type shoppingWithRootQueryResponse = {
    readonly viewer: {
        readonly shoppingWith: {
            readonly title: string | null;
            readonly mainImage: string | null;
            readonly items: ReadonlyArray<{
                readonly metaContentImage: string | null;
            } | null> | null;
            readonly " $fragmentRefs": FragmentRefs<"ShoppingWithWrapper_shoppingWith">;
        } | null;
        readonly " $fragmentRefs": FragmentRefs<"ShoppingWithWrapper_viewer">;
    };
};
export type shoppingWithRootQuery = {
    readonly response: shoppingWithRootQueryResponse;
    readonly variables: shoppingWithRootQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "urlLabel",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "previewId",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isTrade",
    "type": "Boolean!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "previewId",
    "variableName": "previewId"
  },
  {
    "kind": "Variable",
    "name": "urlLabel",
    "variableName": "urlLabel"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "mainImage",
  "args": null,
  "storageKey": null
},
v4 = [
  {
    "kind": "Literal",
    "name": "size",
    "value": "small"
  }
],
v5 = {
  "kind": "ScalarField",
  "alias": "metaContentImage",
  "name": "firstPhotoWebPath",
  "args": (v4/*: any*/),
  "storageKey": "firstPhotoWebPath(size:\"small\")"
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "displayName",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "linkData",
  "storageKey": null,
  "args": null,
  "concreteType": "LinkData",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isLinkable",
      "args": null,
      "storageKey": null
    }
  ]
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v13 = [
  {
    "kind": "Literal",
    "name": "formatType",
    "value": "MOBILE"
  }
],
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "value",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "shoppingWithRootQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "shoppingWith",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "ShoppingWith",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "items",
                "storageKey": null,
                "args": null,
                "concreteType": "Item",
                "plural": true,
                "selections": [
                  (v5/*: any*/)
                ]
              },
              {
                "kind": "FragmentSpread",
                "name": "ShoppingWithWrapper_shoppingWith",
                "args": null
              }
            ]
          },
          {
            "kind": "FragmentSpread",
            "name": "ShoppingWithWrapper_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "shoppingWithRootQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "allShoppingWith",
            "storageKey": null,
            "args": null,
            "concreteType": "ShoppingWithGroup",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "groupName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "shoppers",
                "storageKey": null,
                "args": null,
                "concreteType": "ShoppingWithShopper",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ]
              }
            ]
          },
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "shoppingWith",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "ShoppingWith",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "items",
                "storageKey": null,
                "args": null,
                "concreteType": "Item",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v7/*: any*/),
                  (v9/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "categoryPath",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "ecommerceTrackingParams",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "firstPhotoWebPath",
                    "args": (v4/*: any*/),
                    "storageKey": "firstPhotoWebPath(size:\"small\")"
                  },
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "localizedPdpUrl",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "classification",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemClassification",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "creationDate",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "creators",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemCreator",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "attribution",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "creator",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Creator",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v7/*: any*/)
                        ]
                      },
                      (v7/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isArt",
                    "args": null,
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "vertical",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "shipmentQuotes",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ShipmentQuote",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isComplimentary",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "totalAmount",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "serviceMethod",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ShipmentServiceMethod",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "region",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Region",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "regionName",
                                "args": null,
                                "storageKey": null
                              },
                              (v7/*: any*/)
                            ]
                          },
                          (v7/*: any*/)
                        ]
                      },
                      (v7/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isStorefrontOnly",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isMultiSku",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "variableAttributes",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "VariableAttribute",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "variableAttributeData",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "VariableAttributeSortType",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "swatchSort",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "SwatchSort",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "swatch",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Swatch",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  (v10/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "imageUrl",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  (v7/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v7/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "displayPrice",
                    "storageKey": null,
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "isTrade",
                        "variableName": "isTrade"
                      },
                      {
                        "kind": "Literal",
                        "name": "page",
                        "value": "searchAndBrowse"
                      }
                    ],
                    "concreteType": "ItemDisplayPriceType",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "convertedAmountList",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ConvertedAmountList",
                        "plural": true,
                        "selections": [
                          (v12/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "currency",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "quantityDisplay",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "percentageOff",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "textType",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "amountType",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "showPriceLabel",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "showPriceVariability",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "quickViewDisplay",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "QuickViewDisplayType",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": "mobileTitle",
                        "name": "title",
                        "args": (v13/*: any*/),
                        "storageKey": "title(formatType:\"MOBILE\")"
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "paragraphs",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "QuickViewParagraph",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "key",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "text",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": "mobileText",
                            "name": "text",
                            "args": (v13/*: any*/),
                            "storageKey": "text(formatType:\"MOBILE\")"
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "paragraphAttributeNames",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "QuickViewCategorySegments",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "period",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "origin",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "style",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "periodPrefix",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "creators",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "QuickViewCreator",
                        "plural": true,
                        "selections": [
                          (v10/*: any*/),
                          (v11/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "measurement",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemMeasurement",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "display",
                        "storageKey": "display(addLabel:true,fields:[\"height\",\"width\",\"depth\",\"diameter\",\"length\"],separator:\" \")",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "addLabel",
                            "value": true
                          },
                          {
                            "kind": "Literal",
                            "name": "fields",
                            "value": [
                              "height",
                              "width",
                              "depth",
                              "diameter",
                              "length"
                            ]
                          },
                          {
                            "kind": "Literal",
                            "name": "separator",
                            "value": " "
                          }
                        ],
                        "concreteType": "ItemDisplayMeasurementType",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "unit",
                            "args": null,
                            "storageKey": null
                          },
                          (v14/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "size",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemSize",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": "productPhotos",
                    "name": "photos",
                    "storageKey": "photos(limit:1)",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "limit",
                        "value": 1
                      }
                    ],
                    "concreteType": "ItemPhoto",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "placeholder",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "smallPath",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "masterOrZoomPath",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "versions",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemPhotoVersion",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "webPath",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      (v7/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "description",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "links",
                "storageKey": null,
                "args": null,
                "concreteType": "ShoppingWithLinks",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "links",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ShoppingWithLink",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "label",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  (v2/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "mobileImage",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "subTitle",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "quote",
                "storageKey": null,
                "args": null,
                "concreteType": "ShoppingWithQuote",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "authorName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "image",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "quoteBody",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "shoppingWithRootQuery",
    "id": "app-buyer-misc/289.0.0-2020-11-05T09:16:15.610Z/shoppingWithRootQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = 'ea7fd16a440c20a15f7521ec496fbd31';
export default node;
